import { Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';

import { IconsService } from '@protctc/common/core/services/icon.service';

/** Base app component. */
@Component({
	selector: 'protctw-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.css'],
	imports: [RouterModule],
})
export class AppComponent {
	public constructor() {
		const iconsService = inject(IconsService);

		iconsService.registerIcons();
	}
}
